// import hooks
import { useMutation, useQueryClient } from 'react-query';

// import types
import { EmployerCostSettingsRequest } from '../EmployerCostSettings.types';

// import api's and mutations
import {
  createEmployerCostSettings,
  editEmployerCostSettings
} from 'RestAPIs/admin';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

interface Params {
  isCopy: boolean;
  isNew?: boolean;
  data: EmployerCostSettingsRequest;
}

export const useSave = (handleClose) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ isCopy, isNew, data }: Params) =>
      isCopy || isNew
        ? createEmployerCostSettings(data)
        : editEmployerCostSettings(data),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['EmployerCostSettings', 'list']);
        handleClose();
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};
